import Swiper from 'swiper/bundle';
import Zaiko from './modules/zaiko';
import ColorCart from './modules/colorcart';

document.addEventListener('DOMContentLoaded',function(){

  // main img
  const swiperMain = new Swiper(".js-swiper-main", {
    grabCursor: true,
    pauseOnMouseEnter: true,
    slidesPerView: 1,
    pagination: {
      el: ".main-img-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".main-img-next",
      prevEl: ".main-img-prev"
    }
  });

  // howto
  const swiperSteps = document.querySelectorAll('.js-swiper-step');
  const swiperStepNexts = document.querySelectorAll('.howto-step-next');
  const swiperStepPrevs = document.querySelectorAll('.howto-step-prev');
  const swiperStepPaginations = document.querySelectorAll('.howto-step-pagination');
  for (let i = 0; i < swiperSteps.length; i ++) {
    let number = ('00' + (i+1)).slice(-2);
    swiperSteps[i].classList.add('js-swiper-step' + number);
    swiperStepNexts[i].classList.add('js-swiper-step-next' + number);
    swiperStepPrevs[i].classList.add('js-swiper-step-prev' + number);
    swiperStepPaginations[i].classList.add('js-swiper-step-pagination' + number);
    const swiperStep = new Swiper(".js-swiper-step" + (number), {
      grabCursor: true,
      pauseOnMouseEnter: true,
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        600: {
          slidesPerView: 3,
          spaceBetween: 15,
          navigation: {
            nextEl: ".js-swiper-step-next" + number,
            prevEl: ".js-swiper-step-prev" + number
          }
        }
      },
      pagination: {
        el: ".js-swiper-step-pagination" + number,
        clickable: true,
      },
    });
  }


  //在庫制御
  const carts = document.querySelectorAll('.js-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(!entry.target.classList.contains(zaikoFlag)){
          new Zaiko(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
      root: null,
      rootMargin: "100px",
      threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if(carts){
    carts.forEach(cart => zaikoio.observe(cart));
  }

  // 色玉在庫制御
  const colorCarts = Array.from(document.querySelectorAll('.js-colorcart-irodama'));
  colorCarts.forEach((irodamabtn) => {
    new ColorCart(irodamabtn);
  });

  window.addEventListener('load',function(){


    // series lineup
    const swiperSeriesLineup = new Swiper(".js-swiper-series-lineup", {
      grabCursor: true,
      pauseOnMouseEnter: true,
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        600: {
          slidesPerView: 3,
          spaceBetween: 15,
          navigation: {
            nextEl: ".series-lineup-next",
            prevEl: ".series-lineup-prev"
          }
        }
      },
      pagination: {
        el: ".series-lineup-pagination",
        clickable: true,
      },
    });

  });

});



